
window.intercomInitialized = false;

(function () {
  // as for now it contains stripped out as is code from main page. To be separated later

  document.addEventListener("DOMContentLoaded", function () {
    const lazyImages = document.querySelectorAll("img.lazy");

    if ("IntersectionObserver" in window) {
      const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            img.src = img.dataset.src;
            img.classList.remove("lazy");
            observer.unobserve(img);
          }
        });
      });

      lazyImages.forEach(img => {
        imageObserver.observe(img);
      });
    } else {
      // Fallback for browsers that don't support IntersectionObserver
      let lazyLoadThrottleTimeout;

      function lazyLoad() {
        if (lazyLoadThrottleTimeout) {
          clearTimeout(lazyLoadThrottleTimeout);
        }

        lazyLoadThrottleTimeout = setTimeout(function () {
          const scrollTop = window.pageYOffset;
          lazyImages.forEach(img => {
            if (img.offsetTop < (window.innerHeight + scrollTop + 200)) {
              img.src = img.dataset.src;
              img.classList.remove('lazy');
            }
          });
          if (lazyImages.length === 0) {
            document.removeEventListener("scroll", lazyLoad);
            window.removeEventListener("resize", lazyLoad);
            window.removeEventListener("orientationchange", lazyLoad);
          }
        }, 20);
      }

      document.addEventListener("scroll", lazyLoad);
      window.addEventListener("resize", lazyLoad);
      window.addEventListener("orientationchange", lazyLoad);
    }
  });

  (function () {
    /* The script for calculating the color contrast has been taken from
https://gomakethings.com/dynamically-changing-the-text-color-based-on-background-color-contrast-with-vanilla-js/ */
    var accentColor = getComputedStyle(document.documentElement).getPropertyValue(
      '--background-color');
    accentColor = accentColor.trim().slice(1);

    if (accentColor.length === 3) {
      accentColor = accentColor[0] + accentColor[0] + accentColor[1] + accentColor[1] + accentColor[2] + accentColor[2];
    }

    var r = parseInt(accentColor.substr(0, 2), 16);
    var g = parseInt(accentColor.substr(2, 2), 16);
    var b = parseInt(accentColor.substr(4, 2), 16);
    var yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
    var textColor = (yiq >= 128) ? 'dark' : 'light';

    document.documentElement.className = `has-${textColor}-text`;
  })();

  window.addEventListener('load', function () {
    const images = document.querySelectorAll('img.dynamic-image');

    images.forEach(function (img) {
      const svgSrc = img.getAttribute('data-svg-src');
      if (svgSrc) {
        const svgImage = new Image();
        svgImage.onload = function () {
          img.src = svgSrc;
        };
        svgImage.src = svgSrc;
      }
    });
  });

  window.addEventListener('load', function () {

    window.intercomInitialized = false;

    function initializeIntercom() {
      if (window.intercomInitialized) {
        return;
      }

      window.intercomInitialized = true;

      window.intercomSettings = {
        api_base: "https://api-iam.intercom.io",
        app_id: "uslollsi",
      };

      (function () {
        var w = window;
        var ic = w.Intercom;
        if (typeof ic === "function") {
          ic('reattach_activator');
          ic('update', w.intercomSettings);
        } else {
          var d = document;
          var i = function () {
            i.c(arguments);
          };
          i.q = [];
          i.c = function (args) {
            i.q.push(args);
          };
          w.Intercom = i;
          var l = function () {
            var s = d.createElement('script');
            s.type = 'text/javascript';
            s.async = true;
            s.src = 'https://widget.intercom.io/widget/uslollsi';
            var x = d.getElementsByTagName('script')[0];
            x.parentNode.insertBefore(s, x);
          };
          if (document.readyState === 'complete') {
            l();
          } else if (w.attachEvent) {
            w.attachEvent('onload', l);
          } else {
            w.addEventListener('load', l, false);
          }
        }
      })();

      eventTypes.forEach(event => window.removeEventListener(event, triggerIntercom));
    }

    function triggerIntercom() {
      initializeIntercom();
    }

    const eventTypes = ['mousemove', 'touchstart', 'scroll', 'click'];

    eventTypes.forEach(event => window.addEventListener(event, triggerIntercom));
  });


  window.addEventListener('load', function () {

    document.querySelectorAll('.video-preview').forEach(item => {

      item.addEventListener('click', function (e) {
        e.preventDefault();

        // Reset all desktop preview images to default sizes
        document.querySelectorAll('.desktop-preview img').forEach(img => {
          img.classList.remove('w-[102px]', 'h-[102px]', 'border-[#2A6BBE]');
          img.classList.add('w-[102px]', 'h-[102px]');
        });

        // Reset all mobile preview images to default sizes
        document.querySelectorAll('.mobile-preview img').forEach(img => {
          img.classList.remove('w-[76px]', 'h-[102px]', 'border-[#2A6BBE]');
          img.classList.add('w-[76px]', 'h-[76px]');
        });

        // Apply the active size only to the clicked image
        const clickedImage = this.querySelector('img');
        const isDesktopPreview = this.classList.contains('desktop-preview');

        if (isDesktopPreview) {
          clickedImage.classList.remove('w-[102px]', 'h-[102px]');
          clickedImage.classList.add('w-[102px]', 'h-[102px]', 'border-[#2A6BBE]');
        } else {
          clickedImage.classList.remove('w-[76px]', 'h-[76px]');
          clickedImage.classList.add('w-[76px]', 'h-[76px]', 'border-[#2A6BBE]');
        }

        // Update the video source and poster
        const videoSrc = this.dataset.video;
        const posterSrc = this.dataset.poster;

        const videoContainer = document.getElementById('main-video').parentElement;
        const oldVideo = document.getElementById('main-video');
        videoContainer.removeChild(oldVideo);

        const newVideo = document.createElement('video');
        newVideo.id = 'main-video';
        newVideo.poster = posterSrc;
        newVideo.controls = true;
        newVideo.muted = true;
        newVideo.className = "w-full h-full object-cover min-w-full min-h-full max-w-full max-h-full";

        const newSource = document.createElement('source');
        newSource.src = videoSrc;
        newSource.type = 'video/mp4';
        newVideo.appendChild(newSource);
        videoContainer.appendChild(newVideo);

        // Update the dynamic name
        const name = this.dataset.name;

        const dataNode = Array.from(document.querySelectorAll('.js-hook-videoSliderData a')).filter(list => list.dataset.name === name)[0];

        document.querySelector('h3.text-3xl.font-bold').textContent = name + ", ";
        document.querySelector('.js-hook-review').textContent = '"' + dataNode.dataset.review  + '"';
        document.querySelector('.js-hook-experience').textContent =  dataNode.dataset.experience;
      });
    });
  });

  new LazyLoad({
    elements_selector: ".lazy",
    load_delay: 10
  });
})();
